import {
  GOOGLE_AUTH_QUERY_PARAMS,
  SHOPIFY_SIGNUP_QUERY_PARAMS,
} from '@/constants/queryParams';

export const clearGoogleAuthUrlParams = () => {
  const url = new URL(window.location.href);

  Object.entries(GOOGLE_AUTH_QUERY_PARAMS).forEach(([, value]) => {
    url.searchParams.delete(value);
  });

  window.history.replaceState({}, '', url.toString());
};

export const clearShopifySignUpUrlParams = () => {
  const url = new URL(window.location.href);

  Object.entries(SHOPIFY_SIGNUP_QUERY_PARAMS).forEach(([, value]) => {
    url.searchParams.delete(value);
  });

  window.history.replaceState({}, '', url.toString());
};
